module.exports = __webpack_public_path__ + "img/full3-min.59fa0e45.png";